<template>
  <div data-test-id="SecurityPage" class="ems-page">
    <NavBar>
      <template #left>
        <div class="text-red" data-test-id="closeSecurityButton" @click="onBackClick">Back</div>
      </template>
      <template #center>
        <span>
          <b>Security</b>
        </span>
      </template>
    </NavBar>
    <b-container>
      <br />
      <b-row class="white-background">
        <b-col data-test-id="changePasswordButton" @click="onChangePasswordClick">Change Password</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "@/App/components/NavBar.vue";

export default {
  name: "Settings",
  components: { NavBar },
  methods: {
    onBackClick() {
      this.$router.push({ name: "settings" });
    },
    onChangePasswordClick() {
      this.$router.push({ name: "changePassword" });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.white-background {
  background-color: white;
  color: black;
  border-bottom: 1px solid grey;
}
</style>
